import { render } from "./Income.vue?vue&type=template&id=c885437c&ts=true"
import script from "./Income.vue?vue&type=script&lang=ts"
export * from "./Income.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__